// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2G4Tg","footer":"Form_footer__3magz"};